import FormLabel from "@mui/material/FormLabel";
import Stack from "@mui/material/Stack";
import CheckboxField from "@/components/common/formElements/controlled/CheckboxField";
import InfoAdornment from "@/components/common/formElements/library/InfoAdornment";
import { useCustomFormFieldProps } from "@/components/site-builder/modules/CustomFormModule/hooks/useCustomFormFieldProps";
import type { FormFieldProps } from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/types";

export default function CustomSingleCheckboxField(props: FormFieldProps) {
  const { field } = props;

  const { fieldName, fieldLabel, fieldRules } = useCustomFormFieldProps(field);

  const labelContent = fieldLabel && (
    <Stack alignItems="center" direction="row">
      <FormLabel>{fieldLabel}</FormLabel>
      {field.toolTipText && (
        <InfoAdornment
          tooltip={field.toolTipText}
          inputAdornmentProps={{ sx: { m: 0 } }}
        />
      )}
    </Stack>
  );

  return (
    <div>
      {labelContent}
      <div>
        <CheckboxField
          name={fieldName}
          label={field.checkboxLabel}
          rules={fieldRules}
          fullWidth={false}
        />
      </div>
    </div>
  );
}
